import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/event-bus/page.tsx");
